import Cookies from "js-cookie";
import type { z } from "zod";

export function csrfHeaders(accept: string): Record<string, string> {
  return {
    Accept: accept,
    "Content-Type": "application/json",
    "CSRF-Token": Cookies.get("XSRF-TOKEN") || "",
  };
}

export function responseWithJson<Schema extends z.ZodType>(
  schema: Schema
): (response: Response) => Promise<{ response: Response; data: z.output<Schema> }> {
  return async response => ({
    response,
    data: schema.parse(await response.json()),
  });
}

export async function responseWithText(
  response: Response
): Promise<{ response: Response; text: string }> {
  return { response, text: await response.text() };
}
